import React, { PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Modal from '../../../components/Modal'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import { Metrics, Fonts, Colors } from '../../../Themes'

const CustomInput = styled(Input)`
  margin-bottom: ${Metrics.margins.base};
  
  .inputTitle {
    color: ${Colors.primary};
  }
`
const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const Profile = props => {
  const { handleChange, handleBlur, errors, profile, t, router, next } = props
  return (
    <Modal
      visible
      closeAction={() => router.push('/landing')}
      header={<div className={'header'}>{t('Profile Info')}</div>}
      className='profileModal'>
      <CustomInput
        name='firstName'
        required
        title={t('First Name')}
        value={profile.firstName}
        handleBlur={event => handleBlur('firstName', profile.firstName, errors)}
        handleChange={event => handleChange('firstName', event)}
        error={errors['firstName']}
      />
      <CustomInput
        name='lastName'
        required
        title={t('Last Name')}
        value={profile.lastName}
        error={errors['lastName']}
        handleBlur={event => handleBlur('lastName', profile.lastName, errors)}
        handleChange={event => handleChange('lastName', event)}
      />
      <CustomInput
        required
        name='email'
        type={'e-mail'}
        value={profile.email}
        title={t('E-mail')}
        error={errors['email']}
        handleBlur={event => handleBlur('email', profile.email, errors)}
        handleChange={event => handleChange('email', event)}
      />
      <CustomInput
        required
        name='phoneNumber'
        type={'phone'}
        handleBlur={event =>
          handleBlur('phoneNumber', profile.phoneNumber, errors)}
        value={profile.phoneNumber}
        error={errors['phoneNumber']}
        title={t('Phone Number')}
        handleChange={event => handleChange('phoneNumber', event)}
      />
      <CustomInput
        key='company'
        title={t('Company')}
        value={profile.company}
        handleChange={event => handleChange('company', event)}
      />
      <CustomInput
        key='jobTitle'
        title={t('Job Title')}
        value={profile.jobTitle}
        handleChange={event => handleChange('jobTitle', event)}
      />
      <CustomInput
        name='address'
        required
        title={t('Address')}
        value={profile.address}
        error={errors['address']}
        handleBlur={event => handleBlur('address', profile.address, errors)}
        handleChange={event => handleChange('address', event)}
      />
      <CustomInput
        name='city'
        required
        title={t('City')}
        value={profile.city}
        handleChange={event => handleChange('city', event)}
        error={errors['city']}
        handleBlur={event => handleBlur('city', profile.city, errors)}
      />
      <CustomInput
        name='country'
        required
        title={t('Country')}
        value={profile.country}
        handleChange={event => handleChange('country', event)}
        error={errors['country']}
        handleBlur={event => handleBlur('country', profile.country, errors)}
      />
      <CustomInput
        title={t('Skype Name')}
        value={profile.skypeName}
        handleChange={event => handleChange('skypeName', event)}
      />
      <CustomInput
        title={t('Linkedin Profile')}
        value={profile.linkedinUrl}
        handleChange={event => handleChange('linkedinUrl', event)}
      />
      <Error>{errors.general}</Error>
      <Button
        label={t('Next')}
        onClick={() => next('/landing/signup/settings')}
      />
    </Modal>
  )
}

Profile.propTypes = {
  handleChange: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  profile: PropTypes.object.isRequired,
  router: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Profile
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/Profile.js